/**
 * hub.coranchers.com API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface WorkOrderModel { 
    workOrderId?: number;
    siteId?: number;
    timeStamp?: string;
    shipDateTime?: string;
    reference?: string | null;
    customerNumber?: string | null;
    statusId?: number;
    customerName?: string | null;
}

